import { Button, Hidden, Icon, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import { useTranslation } from "react-i18next";
import ButtonLink from "./buttonLink";
import ButtonLinkIcon from "./buttonLinkIcon";
import { DeleteTwoTone } from "@mui/icons-material";
const Delete = ({ item, onDelete, iconOnly = true, ...rest }) => {
  const { t } = useTranslation(["common"]);
  return (
    <React.Fragment>
      <Hidden only={["xs", "sm"]}>
        {iconOnly ? <IconButton
          title={"Delete"}
          aria-label={"title"}
          onClick={(event) => onDelete(item, event)}
          // style={{padding:"0px"}}
          {...rest}
          size="large">
          <DeleteTwoTone color="error" />
        </IconButton>
          : <Button
            title={"Delete"}
            // variant={variant ? variant : "contained"}
            // className={classes.buttonSpace}
            // size={size}
            onClick={(event) => onDelete(item, event)}
            startIcon={<DeleteTwoTone color="error" />}
            {...rest}
          >
            {t("common:Delete")}
          </Button>
        }
      </Hidden>
      <Hidden only={["md", "lg", "xl"]}>
        <IconButton
          title={"Delete"}

          aria-label={"title"}
          onClick={(event) => onDelete(item, event)}
          // style={{padding:"0px"}}
          {...rest}
          size="large">
          <DeleteTwoTone color="error" />
        </IconButton>
      </Hidden>

    </React.Fragment>
  );
};

export default Delete;
